module.exports = __webpack_public_path__ + "static/media/notification-svgrepo-com (9).b7ec636b.svg";